import { exportEmployees, exportToExcelAPI, generateCSV, downloadCSV, downloadExcel } from "../services/exportService";
import { apiFetch } from "../../../context/AuthContext";

const API_URL = process.env.REACT_APP_BASE_URL;

/**
 * Export archived employees via server API and trigger download.
 * params.filters: { searchTerm, filterCompany, filterWorkingCompany, filterDepartment, dateFrom, dateTo }
 * params.showAlert: optional alert function
 * params.text, params.language: optional localization
 */
export async function handleExportArchive({ filters = {}, showAlert, text = {}, language = "en" } = {}) {
  try {
    const clientName = localStorage.getItem("clientName") || "";
    const response = await apiFetch(`${API_URL}/employees/archived/export`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ filters: { ...filters, clientName } }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      
      throw new Error(errorData.error || `HTTP ${response.status}`);
    }

    const blob = await response.blob();
    const filename = `archived_employees_${Date.now()}.xlsx`;
    // Trigger download
    downloadExcel(blob, filename.replace(/\.xlsx$/, ""));

    if (typeof showAlert === "function") {
      showAlert({
        title: (text[language] && text[language].export) || "Export",
        message: language === "ar" ? "تم تحميل بيانات الأرشيف بنجاح!" : "Archived employees exported successfully!",
        variant: "success",
      });
    }

    return { success: true, filename };
  } catch (err) {
    if (typeof showAlert === "function") {
      showAlert({
        title: (text[language] && text[language].export) || "Export",
        message: err.message || (language === "ar" ? "فشل في تحميل بيانات الأرشيف" : "Failed to export archived employees"),
        variant: "error",
      });
    }
    throw err;
  }
}

/**
 * Export filtered employees to Excel (with CSV fallback).
 * params.employees: array of employees
 * params.filters: filter object
 * params.showAlert, params.text, params.language: optional
 */
export async function handleExportToExcel({ employees = [], filters = {}, showAlert, text = {}, language = "en" } = {}) {
  try {
    const result = await exportEmployees(employees, filters);

    if (typeof showAlert === "function") {
      showAlert({
        title: (text[language] && text[language].export) || "Export",
        message: (language === "ar" ? "تم التصدير بنجاح" : "Exported successfully"),
        variant: "success",
      });
    }

    return result;
  } catch (err) {
    if (typeof showAlert === "function") {
      showAlert({
        title: (text[language] && text[language].export) || "Export",
        message: err.message || (language === "ar" ? "فشل التصدير" : "Failed to export employees"),
        variant: "error",
      });
    }
    throw err;
  }
}

// Re-export CSV helpers for consumers that previously imported them
export { generateCSV, downloadCSV };
// `downloadExcel` is provided by `exportService` (imported above)
